<template>
  <div class="summary-wrap">
    <div class="summary-grid">
      <div class="stat-card ongoing">
        <h6 class="stat-title">Ongoing</h6>
        <hr class="stat-divider">
        <div class="stat-body">
          <h3 class="stat-value">{{ summary.ongoing }}</h3>
          <i class="fas fa-utensils stat-icon"></i>
        </div>
      </div>

      <div class="stat-card completed">
        <h6 class="stat-title">Completed</h6>
        <hr class="stat-divider">
        <div class="stat-body">
          <h3 class="stat-value">{{ summary.completed }}</h3>
          <i class="fas fa-circle-check stat-icon"></i>
        </div>
      </div>

      <div class="stat-card cancelled">
        <h6 class="stat-title">Cancelled</h6>
        <hr class="stat-divider">
        <div class="stat-body">
          <h3 class="stat-value">{{ summary.cancelled }}</h3>
          <i class="fas fa-ban stat-icon"></i>
        </div>
      </div>

      <div class="stat-card collection clickable" @click="goToCollectionReport">
        <h6 class="stat-title">Collection</h6>
        <hr class="stat-divider">
        <div class="stat-body">
          <h3 class="stat-value">{{ summary.collection }}</h3>
          <i class="fas fa-wallet stat-icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import handleHospital from '@/services/modules/hospital';
import {formatLocalDate} from '@/services/utils/global';

const route = useRoute();
const router = useRouter();
const {fetchRestaurantSummary} = handleHospital();

const companyId = computed(() => route.params.companyId);

const today = formatLocalDate(new Date());
const summary = ref({ongoing: 0, completed: 0, cancelled: 0, collection: 0});

onMounted(() => {
  getSummary();
});

const getSummary = async () => {
  const query = `?company_id=${companyId.value}&start_date=${today}&end_date=${today}`;
  const res = await fetchRestaurantSummary(query);
  if (!res.status) {
    return;
  }
  summary.value = res.data;
};

const goToCollectionReport = () => {
  const query = {...route.query, start: today, end: today};
  const resolved = router.resolve({
    name: 'sales-collection-report',
    params: route.params,
    query: query
  });
  window.open(resolved.href, '_blank');
};

defineExpose({getSummary});
</script>

<style scoped>
.summary-wrap {
  padding: 0;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.stat-card {
  border-radius: 10px;
  padding: 12px 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.stat-card.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.stat-card.clickable:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

.stat-title {
  margin: 0;
  font-weight: 700;
  color: #2f3a4c;
}

.stat-divider {
  margin: 8px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.stat-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.stat-value {
  margin: 0;
  font-weight: 800;
  font-size: 30px;
  color: #2f3a4c;
}

.stat-icon {
  font-size: 30px;
  opacity: 0.85;
}

.stat-card.ongoing {
  background: #d9f6fb;
}

.stat-card.ongoing .stat-icon {
  color: #00b8d4;
}

.stat-card.completed {
  background: #e3f9ec;
}

.stat-card.completed .stat-icon {
  color: #28c76f;
}

.stat-card.cancelled {
  background: #fdeaea;
}

.stat-card.cancelled .stat-icon {
  color: #ea5455;
}

.stat-card.collection {
  background: #eeedfd;
}

.stat-card.collection .stat-icon {
  color: #7367f0;
}
</style>
